module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_4_1-3136b32d783a2961cda41cb181c7171c.webp";